import { create } from "zustand";

interface NotifyStudentsModalState {
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
}

export const useNotifyStudentsModalStore = create<NotifyStudentsModalState>(
  set => ({
    isDirty: false,
    setIsDirty: (isDirty: boolean) => set({ isDirty }),
  }),
);
